<template>
  <AppStack direction="flex-col">
    <AppStack
      align-items="items-baseline"
      class="sticky top-0 pt-2 pb-[6px] gap-[6px] px-4 bg-bg-elevation-2 z-[1]
        border-b-[0.5px] border-solid border-t-0 border-l-0 border-r-0
        border-border-elevation-2-secondary"
    >
      <div
        class="bg-bg-elevation-2-breaker opacity-40 absolute top-0 left-0 w-full h-full"
      />
      <AppTypography
        :text="props.name"
        color="text-fg-elevation-2-primary"
        name="text-xs-4-bold"
        class="relative"
      />
      <AppTypography
        v-if="props.batch?.batch?.createdAt"
        :text="DateFnsFormat(new Date(props.batch.batch.createdAt), 'HH:mm')"
        color="text-fg-elevation-2-tertiary"
        name="text-xs-4-bold"
        class="relative"
      />
    </AppStack>
    <OrderModalHomeMenuitemsList
      :items="props.batch?.menuItems"
      :order-id="props.orderId"
      class="flex-1"
      :quantity-changable="props.quantityChangable"
      :deletable="props.deletable"
      :status-changable="statusChangable"
      @increase-quantity="emit('increase-quantity', $event)"
      @decrease-quantity="emit('decrease-quantity', $event)"
      @add-comment="emit('add-comment', $event)"
      @delete="emit('delete', $event)"
      @tap="emit('tap', $event)"
      @status-change="emit('status-change', $event)"
    />
  </AppStack>
</template>

<script setup lang="ts">
import { format as DateFnsFormat } from 'date-fns'
import AppTypography from '@restify/packages/design-system/low-level/AppTypography.vue'
import AppStack from '@restify/packages/design-system/low-level/AppStack.vue'
import OrderModalHomeMenuitemsList from './OrderModalHomeMenuitemsList.vue'
import OrderModalHomeMenuitemsListItem from './OrderModalHomeMenuitemsListItem.vue'
import { type ComponentProps } from '@restify/packages/types'

type OrderModelHomeMenuitemsListProps = ComponentProps<
  typeof OrderModalHomeMenuitemsListItem
>

const emit = defineEmits<{
  'increase-quantity': [index: number],
  'decrease-quantity': [index: number],
  'add-comment': [payload: { index: number, callback: () => void }],
  'status-change': [payload: { status: string, id: string }],
  'delete': [id: string],
  'tap': [id: string],
}>()
const props = defineProps<{
  batch?: {
    batch?: {
      id?: string
      createdAt?: number
    }
    menuItems?: Array<OrderModelHomeMenuitemsListProps & { _id: string }>
  }
  name: string
  orderId?: string
  quantityChangable?: boolean
  statusChangable?: boolean
  deletable?: boolean
}>()
</script>
